import { gameState } from '@js/state';
export default class HintScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'HintScene',
    });
  }

  preload() {}

  create() {
    this.timesclicked = 0;

    this.hintAnimations();
    this.overlay = this.add.image(0, 0, 'overlay').setOrigin(0).setAlpha(0);

    this.hintText = this.add.image(72, 656, 'hintText').setOrigin(0, 1).setScale(0);

    this.text1 = this.add
      .text(95, 630, '', { fontFamily: 'font2', fontSize: '18px', fill: '#000000' })
      .setOrigin(0, 1)
      .setDepth(1)
      .setScale(0);

    this.hintButton = this.physics.add
      .sprite(-25, 550, 'hintFinalAnim')
      .setOrigin(0)
      .setScale(0.8)
      .setInteractive({ cursor: 'pointer', pixelPerfect: true });

    this.hintButton.on('pointerdown', () => {
      if (gameState.attempts == 1) {
        this.hintText.setTexture('hintText');
        this.hintClose.y = 406;
      } else {
        this.hintText.setTexture('hintText2');
        this.hintClose.y = 486;
      }

      gameState.hints++;
      this.hintButton.play('idle');
      this.scene.pause('GameScene');
      this.overlay.setAlpha(1);

      this.tweens.add({
        targets: [this.hintText, this.text1],
        scale: 1,
        duration: 500,

        ease: 'Sine.easeInOut',

        onComplete: () => {
          this.hintClose.setAlpha(1);
        },
      });
    });

    this.hintClose = this.add
      .image(516, 406, 'hintClose')
      .setOrigin(0)
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.hintClose.on(
      'pointerdown',
      () => {
        this.scene.resume('GameScene');
        this.overlay.setAlpha(0);
        this.hintText.setScale(0);
        this.text1.setScale(0);

        this.hintClose.setAlpha(0);
        //this.hintButton.play("pop_out");
      },
      this,
    );
  }

  hintAnimations() {
    this.anims.create({
      key: 'pop',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 0,
        end: 35,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });

    this.anims.create({
      key: 'breathe',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 66,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.anims.create({
      key: 'idle',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 36,
        end: 37,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 1,
      repeat: -1,
    });

    this.anims.create({
      key: 'pop_out',
      frames: this.anims.generateFrameNames('hintFinalAnim', {
        start: 35,
        end: 0,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 60,
      repeat: 0,
    });
  }

  update() {
    if (gameState.attempts == 0) {
      this.hintButton.setVisible(false);
    }
    if (gameState.hneed && gameState.attempts > 0) {
      gameState.hneed = false;

      if (gameState.attempts == 1) {
        this.hintButton.setVisible(true);
        this.hintButton.play('pop');
        this.time.delayedCall(
          600,
          () => {
            this.hintButton.play('breathe');
          },
          [],
          this,
        );
      } else {
        this.hintButton.setVisible(true);
        this.time.delayedCall(
          200,
          () => {
            this.hintButton.play('breathe');
          },
          [],
          this,
        );
      }
    }

    if (gameState.hintClose) {
      gameState.hintClose = false;
      this.hintButton.play('pop_out');
    }
  }
}

//hintClose will be true when a correct answer is given. It will be false otherwise.
